// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"i1-z","inlineTitle":"j1-z","sponsoredAdsWrapper":"k1-z","marketplaceRecosWrapper":"l1-z"};